import { AppLink } from '../../lib/app-navigation';
import { Component, useEffect, useRef, type ReactNode } from 'react';
import type { Language } from '../../lib/crs';
import './RouteErrorBoundary.css';

/** Isolate a failed route without unmounting navigation or the other cached tools. */
export class RouteErrorBoundary extends Component<{
  children: ReactNode;
  fallback: ReactNode;
  resetKey: string;
}, { failed: boolean; resetKey: string }> {
  state = { failed: false, resetKey: this.props.resetKey };
  static getDerivedStateFromError() { return { failed: true }; }
  static getDerivedStateFromProps(props: { resetKey: string }, state: { resetKey: string }) {
    return props.resetKey === state.resetKey ? null : { failed: false, resetKey: props.resetKey };
  }
  render() { return this.state.failed ? this.props.fallback : this.props.children; }
}

export function RouteErrorState({ language, returnHref }: { language: Language; returnHref: string }) {
  const heading = useRef<HTMLHeadingElement>(null);
  useEffect(() => { heading.current?.focus(); }, []);
  return <main id="main-content" className="halo-route-error">
    <h1 ref={heading} tabIndex={-1}>{language === 'zh' ? '暂时无法打开此页' : 'This page couldn’t open'}</h1>
    <div className="halo-route-error-actions">
      <button type="button" onClick={() => window.location.reload()}>{language === 'zh' ? '重新加载' : 'Reload page'}</button>
      <AppLink to={returnHref}>{language === 'zh' ? '返回继续操作' : 'Return to your task'}</AppLink>
    </div>
  </main>;
}
